import React, { FC, useContext, useState } from 'react';

import { Box } from '@src/atoms/Box';
import { Icon } from '@src/atoms/Icon';
import { Dialog } from '../Dialog';
import { IMessage, IZoomProps } from './models';
import { BreakpointsContext } from '@centra/ui-global-context';
import { classnames } from '@src/utils/classnames';
import { Carousel } from '../Carousel';
import { ZoomPreview } from './_Preview/ZoomPreview';
import { ZoomMessageInfo } from './_MessageInfo/ZoomMessageInfo';
import { useHovered } from '@src/hooks/propsHooks/useHovered';

import styled from './Zoom.module.scss';
import { getCreationDate } from './utils';

export const Zoom: FC<IZoomProps> = ({
  files = [],
  open,
  isFileNameShown,
  importanceLevel,
  message,
  activeIndex: activeIndexProps = 0,
  onClose,
  attachedFilesHistory,
}) => {
  const { isMobile } = useContext(BreakpointsContext);
  const [activeIndex, setActiveIndex] = useState(activeIndexProps);
  const { hoveredCallbacks, isHovered } = useHovered();

  const dialogClasses = classnames(styled.dialogZoom, isMobile && styled.dialogZoomMobile);
  const backdropClasses = classnames(styled.backdrop, isMobile && styled.backdropMobile);
  const closeClasses = classnames(styled.closeIconContainer, isMobile && styled.closeIconContainerMobile);

  const creationDate = getCreationDate(message, attachedFilesHistory, files, activeIndex);
  const showArrows = !isMobile && files.length > 1;

  return (
    <Dialog
      id={'zoomDialog'}
      open={open}
      onClose={onClose}
      importanceLevel={importanceLevel}
      className={dialogClasses}
      backdropClasses={backdropClasses}
    >
      <Box className={closeClasses}>
        <Icon name={'close'} view={'basicWhite'} onClick={onClose} id="closeZoom" />
      </Box>

      <Box {...hoveredCallbacks}>
        <Carousel
          id="Zoom_Carousel"
          className={styled.carousel}
          showArrows={!isMobile && files.length > 1}
          onChange={setActiveIndex}
          selectedItem={activeIndex}
          renderArrowNext={(clickHandler) =>
            showArrows && (
              <Carousel.Arrow
                onClick={clickHandler}
                type="right"
                isHidden={!isHovered}
                className={styled.carouselArrowRight}
                data-id="arrowRight"
              />
            )
          }
          renderArrowPrev={(clickHandler) =>
            showArrows && (
              <Carousel.Arrow
                onClick={clickHandler}
                type="left"
                isHidden={!isHovered}
                className={styled.carouselArrowLeft}
                data-id="arrowLeft"
              />
            )
          }
          ref={(ref) => {
            //Это костыль т.к. модалка перехватывает фокус на себя при открытии.
            //A для того, чтобы работала функция управления через клавиши сходу, мы должны поставить фокус на карусель
            setTimeout(() => {
              ref?.forceFocus();
            }, 500);
          }}
        >
          {files.map((file, i) => (
            <ZoomPreview
              key={file.id}
              isActive={i === activeIndex}
              file={file}
              isFileNameShown={isFileNameShown}
              onClose={onClose}
            />
          ))}
        </Carousel>
      </Box>

      {(message || attachedFilesHistory) && (
        <ZoomMessageInfo
          message={message ? message : (files[activeIndex].message as IMessage)}
          creationDate={creationDate}
          fileHref={files[activeIndex].mainUrl}
        />
      )}
    </Dialog>
  );
};
